/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OptionalMapInputConversationTypeTemplateKindDtoString
 */
export interface OptionalMapInputConversationTypeTemplateKindDtoString {
    /**
     * 
     * @type {boolean}
     * @memberof OptionalMapInputConversationTypeTemplateKindDtoString
     */
    defined?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof OptionalMapInputConversationTypeTemplateKindDtoString
     */
    map?: { [key: string]: string; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof OptionalMapInputConversationTypeTemplateKindDtoString
     */
    set?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof OptionalMapInputConversationTypeTemplateKindDtoString
     */
    value?: { [key: string]: string; } | null;
}

/**
 * Check if a given object implements the OptionalMapInputConversationTypeTemplateKindDtoString interface.
 */
export function instanceOfOptionalMapInputConversationTypeTemplateKindDtoString(value: object): value is OptionalMapInputConversationTypeTemplateKindDtoString {
    return true;
}

export function OptionalMapInputConversationTypeTemplateKindDtoStringFromJSON(json: any): OptionalMapInputConversationTypeTemplateKindDtoString {
    return OptionalMapInputConversationTypeTemplateKindDtoStringFromJSONTyped(json, false);
}

export function OptionalMapInputConversationTypeTemplateKindDtoStringFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptionalMapInputConversationTypeTemplateKindDtoString {
    if (json == null) {
        return json;
    }
    return {
        
        'defined': json['defined'] == null ? undefined : json['defined'],
        'map': json['map'] == null ? undefined : json['map'],
        'set': json['set'] == null ? undefined : json['set'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function OptionalMapInputConversationTypeTemplateKindDtoStringToJSON(json: any): OptionalMapInputConversationTypeTemplateKindDtoString {
    return OptionalMapInputConversationTypeTemplateKindDtoStringToJSONTyped(json, false);
}

export function OptionalMapInputConversationTypeTemplateKindDtoStringToJSONTyped(value?: OptionalMapInputConversationTypeTemplateKindDtoString | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'defined': value['defined'],
        'map': value['map'],
        'set': value['set'],
        'value': value['value'],
    };
}

